import { FC } from 'react';
import styles from './TaskList.module.scss';

export interface TaskItem {
  id: string;
  title: string;
  description: string;
  href: string;
  iconType: 'asset' | 'drawings' | 'criteria';
}

const DEFAULT_TASKS: TaskItem[] = [
  {
    id: 'asset-manual',
    title: 'Find an asset or equipment manual',
    description: 'Search by ID, manufacturer, location or description',
    href: '/more-info',
    iconType: 'asset',
  },
  {
    id: 'browse-drawings',
    title: 'Browse drawings by floor or discipline',
    description: 'Plans, schematics, XREFs and archive material',
    href: '/drawings',
    iconType: 'drawings',
  },
  {
    id: 'review-criteria',
    title: 'Review design criteria',
    description: 'Mechanical, electrical and base-build records',
    href: '/design-criteria/mechanical',
    iconType: 'criteria',
  },
];

export const TaskList: FC = () => {
  return (
    <section className={styles.container} aria-labelledby="tasks-heading">
      <div className={styles.header}>
        <h3 id="tasks-heading" className={styles.title}>
          Start with a task
        </h3>
        <p className={styles.subtitle}>Common routes into the information you need.</p>
      </div>

      <ul className={styles.list}>
        {DEFAULT_TASKS.map((task) => (
          <li key={task.id}>
            <a href={task.href} className={styles.taskItem}>
              <div className={styles.iconBox} aria-hidden="true">
                {task.iconType === 'asset' && (
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
                    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
                    <line x1="12" y1="22.08" x2="12" y2="12" />
                  </svg>
                )}
                {task.iconType === 'drawings' && (
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <rect x="3" y="3" width="18" height="18" rx="2" />
                    <line x1="3" y1="9" x2="21" y2="9" />
                    <line x1="9" y1="21" x2="9" y2="9" />
                  </svg>
                )}
                {task.iconType === 'criteria' && (
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <line x1="4" y1="6" x2="20" y2="6" />
                    <line x1="4" y1="12" x2="14" y2="12" />
                    <line x1="4" y1="18" x2="18" y2="18" />
                  </svg>
                )}
              </div>
              <div className={styles.taskContent}>
                <span className={styles.taskTitle}>{task.title}</span>
                <span className={styles.taskDescription}>{task.description}</span>
              </div>
              <span className={styles.chevron} aria-hidden="true">
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polyline points="9 18 15 12 9 6" />
                </svg>
              </span>
            </a>
          </li>
        ))}
      </ul>
    </section>
  );
};
